import { render, staticRenderFns } from "./PswChange.vue?vue&type=template&id=615826f0&scoped=true&"
import script from "./PswChange.vue?vue&type=script&lang=js&"
export * from "./PswChange.vue?vue&type=script&lang=js&"
import style0 from "./PswChange.vue?vue&type=style&index=0&id=615826f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615826f0",
  null
  
)

/* custom blocks */
import block0 from "./PswChange.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports